import React, { FunctionComponent, SVGAttributes } from 'react';

export const ArrowDropDownIcon: FunctionComponent<SVGAttributes<SVGElement>> = (props) => (
  <svg width='16' height='10' viewBox='0 0 16 10' fill='none' {...props}>
    <path d='M15.5 1L8 8.5L0.499999 1' stroke='white' />
  </svg>
);
